export interface IGetAuthorNameParams {
  firstName?: string | null;
  lastName?: string | null;
  cianUserId: number;
}

export function getAuthorName({ firstName, lastName, cianUserId }: IGetAuthorNameParams) {
  if (firstName && lastName) {
    return `${lastName} ${firstName}`;
  }

  return `${cianUserId}`;
}
